<script lang="ts">
    import { overlay } from "../../../store"

    let timeout = 5
    let interval = setInterval(() => {
        timeout--
        if (timeout == 0) {
            clearInterval(interval)
        }
    }, 1000)

    function closeMessage() {
        $overlay.show = false
        sessionStorage.setItem("dealerLoginMessage", "true")
        window.setTimeout(() => {
            window.location.reload()
        }, 10)
    }
</script>

<section class="section_padding">
    <div class="container">
        <h2>WICHTIGE INFORMATION</h2>

        <p>Im Shop finden Sie neben Ersatzteilen ein spezielles Sortiment an RENZ und MEFA Produkten.</p>
        <p>Für Ersatzteile gewähren wir die Ihnen bekannten Rabatte und Konditionen.</p>
        <p>
            Für das spezielle Brief- und Paketkastensortiment gelten die angezeigten Netto-Fixpreise. Diese sind von
            Ihren Standard- und Sonderkonditionen ausgeschlossen. Der im Shop angezeigte Preis entspricht dem finalen
            Rechnungsbetrag.
        </p>
        <p>Bei Fragen hierzu wenden Sie sich gerne an den Ihnen bekannten Ansprechpartner.</p>
        <button class="button primary" onclick={closeMessage} disabled={!!timeout}>
            OK, ich habe verstanden
            {#if timeout > 0}
                ({timeout})
            {/if}
        </button>
    </div>
</section>
